
import {mapActions, mapState} from "vuex";
import SimpleActionButton from "@/components/shared/simple-action-button";

export default {
  name: "SelectStoreDialog",

  components: {
    SimpleActionButton,
  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {};
  },

  async mounted(){
    if(this.$auth.loggedIn && !this.stores?.length) {
      await this.fetchStores();
    }
  },

  computed: {
    ...mapState("common/stores", ["stores"]),
  },

  methods: {
    ...mapActions('common/stores',['fetchStores']),
    close() {
      this.$emit("close", false);
    },
    async onItemSelected(item) {
      this.$emit("onStoreSelected", item);
    },
  },
};
